package tools

import androidx.compose.runtime.MutableState
import androidx.compose.runtime.Stable
import androidx.compose.runtime.mutableStateOf
import androidx.compose.ui.graphics.vector.ImageVector
import org.jetbrains.compose.resources.StringResource
import tk.mallumo.compose.navigation.ArgumentsNavigation
import tk.mallumo.compose.navigation.Node

@Stable
data class TabDefinition(
    val node: Node,
    var args: ArgumentsNavigation,
    override var icon: ImageVector,
    override var label: StringResource,
    override var tag: String = label.key,
    override var onClick: TabDefinition.(index: Int) -> Unit,
    val expanded: MutableState<Boolean> = mutableStateOf(false),
    val submenu: List<TabDefinition> = listOf()
) : ImplTabDefinition<TabDefinition>

@Stable
data class TabDefinitionSimple(
    override var icon: ImageVector,
    override var label: StringResource,
    override var tag: Any = Unit,
    override var onClick: TabDefinitionSimple.(index: Int) -> Unit
) : ImplTabDefinition<TabDefinitionSimple>

@Stable
private interface ImplTabDefinition<T> {
    val icon: ImageVector
    val label: StringResource
    val onClick: T.(index: Int) -> Unit
    val tag: Any
}

@Stable
data class TabEntry<T>(
    val icon: ImageVector,
    val label: StringResource,
    val onClick: (TabEntry<T>) -> Unit,
    var args: ArgumentsNavigation = ArgumentsNavigation(),
    val tag: T
)
